/**
 * DutyService
 * Service for Duty entity operations
 * Route: api/duties
 */
import { CrudService } from '../base/CrudService';
/**
 * DutyService
 * Handles duty CRUD operations and duty-specific queries
 */
export class DutyService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? DutyService.DEFAULT_SERVICE_PATH,
            basePath: DutyService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY DEPARTMENT ====================
    /**
     * Get duties by department
     * GET api/duties/by-department/{departmentId}
     */
    async getByDepartment(departmentId) {
        const response = await this.getByDepartmentRaw(departmentId);
        return response.data ?? [];
    }
    /**
     * Get duties by department with full response
     */
    getByDepartmentRaw(departmentId) {
        const endpoint = this.getEndpoint('by-department', `by-department/${departmentId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== MODELVIEW ENDPOINTS ====================
    /**
     * Get duty ModelView by ID
     * GET api/duties/view/{id}
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Duty ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get duty ModelView by ID with full response
     */
    getViewRaw(id) {
        const endpoint = this.getEndpoint('view-by-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Get all duty ModelViews with pagination
     * GET api/duties/view?page={page}&pageSize={pageSize}
     */
    async getAllViews(page = 1, pageSize = 50) {
        const response = await this.getAllViewsRaw(page, pageSize);
        if (!response.data) {
            throw new Error('Failed to retrieve duty ModelViews');
        }
        return response.data;
    }
    /**
     * Get all duty ModelViews with full response
     */
    getAllViewsRaw(page = 1, pageSize = 50) {
        const endpoint = this.getEndpoint('view-all', 'view');
        const url = this.buildUrlWithParams(endpoint, { page, pageSize });
        return this.http.get(url);
    }
    /**
     * Get duty ModelViews by department
     * GET api/duties/view/by-department/{departmentId}
     */
    async getViewsByDepartment(departmentId) {
        const response = await this.getViewsByDepartmentRaw(departmentId);
        return response.data ?? [];
    }
    /**
     * Get duty ModelViews by department with full response
     */
    getViewsByDepartmentRaw(departmentId) {
        const endpoint = this.getEndpoint('view-by-department', `view/by-department/${departmentId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
DutyService.DEFAULT_SERVICE_PATH = 'hr';
DutyService.BASE_PATH = 'api/duties';
//# sourceMappingURL=DutyService.js.map